export const none = {
    label: "None",
    value: "none",
};

export const newProduct = {
    label: "New",
    value: "new",
}

export const limitedTime = {
    label: "Limited Time",
    value: "limited_time",
};

export const vegetarian = {
    label: "Vegetarian",
    value: "vegetarian",
}

export const fanFavorite = {
    label: "Fan Favorite",
    value: "fan_favorite"
}

export const newAndImproved = {
    label: "New and Improved",
    value: "new_and_improved",
}